import styled from "styled-components";
import { Button, Flex } from "@ebscois/react-component-library";

export const BackgroundAndBorderWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  background: ${({ theme }) => theme.colors.white};
`;

export const ConsentMessagingWrapper = styled(Flex)`
  width: 100%;
  padding: ${({ theme }) => theme.space.md} 1.25rem;
  margin: 0 auto;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
  }
`;

export const ConsentControls = styled(Flex)`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.md};
    width: 100%;
  }
`;

export const DismissConsent = styled(Button)`
  margin-left: ${({ theme }) => theme.space.md};
`;
